class TimelineDialog {
  constructor() {
    document.addEventListener('click', e => this.handleClick(e))
  }

  handleClick(e) {
    const link = e.target.closest('[href*="#modal-"]')
    const closeBtn = e.target.closest('[data-modal-close]')
    const lightboxLink = e.target.closest('.timeline__modal [data-lightbox]')

    // click on the other link, lightgallery not init inside of the modal 
    if (lightboxLink) {
      e.preventDefault()
      e.stopPropagation()
      const target = document.querySelector(`[href="${lightboxLink.getAttribute('href')}"]`)
      if (target) {
        target.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true
        }))

      }
    }

    if (link) {
      e.preventDefault()
      e.stopPropagation()

      const id = new URL(link.href).hash.slice(1)


      this.showModal(id)
      return
    }

    if (closeBtn) {
      closeBtn.closest('dialog')?.close()
      return
    }
  }

  showModal(id) {
    const modal = document.getElementById(id)

    if (!modal || modal.nodeName !== 'DIALOG') return
    if (!modal.open) {
      modal.show()
    }
  }
}

export default TimelineDialog